import FormControl from '../../v2/components/FormControl';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../../dataSensitivity/highlySensitiveMaskedDisplay';
import { ShowHighlySensitiveValueButton } from '../../dataSensitivity/ShowHighlySensitiveValueButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyInputHighlySensitiveFloating = props => {
  const {
    className,
    formControlProps,
    inputProps = {}
  } = props;
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, formControlProps, {
    formControlUse: "floating",
    overlayContent: /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
      isVisible: true
    }),
    hideEditIcon: true,
    isStatic: true,
    children: /*#__PURE__*/_jsx("span", Object.assign({
      className: className
    }, getDataAttributes(inputProps), {
      children: HIGHLY_SENSITIVE_MASKED_DISPLAY
    }))
  }));
};